/*
    Menu Scripts
*/
function scroller() {
    var self = this;

    // Initalise the animated scrolling
    // Process anchor links
    for (var i = 0; i < document.getElementsByTagName("A").length; i++) {
        if (document.getElementsByTagName("A")[i].href.contains("#") && document.getElementsByTagName("A")[i].href.length > 1) {
            new anchorlink(wcbs.dom.get(document.getElementsByTagName("A")[i]), this);
        }
    }

    this.scrollstatus = "idle";
    this.scrollComplete = function () {
        self.scrollstatus = "idle";
    }

    this.slidescroll = function (t) {
        var sY;
        if (window.scrollY) {
            sY = window.scrollY;
        }
        else {

            sY = (document.body.scrollTop > document.documentElement.scrollTop) ? document.body.scrollTop : document.documentElement.scrollTop;

        }
        window.scrollTo(sY, t.replace("px", ""));
    }

    this.animindex = wcbs.animate.add(this, { from: 0, to: document.body.offsetHeight, delay: 5, duration: 1000, property: "slidescroll", motion: wcbs.animate.easeOutQuint, unit: "px", oncomplete: self.scrollComplete });

    this.stopscroll = function () {
        if (self.scrollstatus != "idle") {
            wcbs.animate.objects[self.animindex].stop();
            self.scrollstatus = "idle";
            if (wcbs.isIE) {
                window.detachEvent("onmousewheel", self.stopscroll);
            }
            else if (wcbs.isFF) {
                window.removeEventListener("DOMMouseScroll", self.stopscroll, false);
            }
            else {
                window.removeEventListener("mousewheel", self.stopscroll, false);
            }
        }
    }

    this.startscroll = function (t, v) {
        if (self.scrollstatus == "idle") {
            // Check max scroll
            var st
            st = v ? v : (wcbs.getRelativePosition(t.object, document.body).y > 0) ? (wcbs.getRelativePosition(t.object, document.body).y) : 0;

            var sm;

            if (window.scrollMaxY) {
                sm = window.scrollMaxY;
            }
            else {
                sm = ((document.body.scrollHeight > document.documentElement.scrollHeight) ? document.body.scrollHeight : document.documentElement.scrollHeight) - window.innerHeight;
            }

            if (st > sm) {
                st = sm;
            }

            var sY;
            if (window.scrollY) {
                sY = window.scrollY;
            }
            else {
                sY = (document.body.scrollTop > document.documentElement.scrollTop) ? document.body.scrollTop : document.documentElement.scrollTop;
            }

            wcbs.animate.objects[self.animindex].options.from = sY;
            wcbs.animate.objects[self.animindex].options.to = st;
            self.scrollstatus = "scrolling";
            wcbs.animate.objects[self.animindex].start();

            if (wcbs.isIE) {
                window.attachEvent("onmousewheel", self.stopscroll);
            }
            else if (wcbs.isFF) {
                window.addEventListener("DOMMouseScroll", self.stopscroll, false);
            }
            else {
                window.addEventListener("mousewheel", self.stopscroll, false);
            }
        }
    }

}
var scrl;
wcbs.onloadAdd("scrl = new scroller()");

function anchorlink(o, p) {
    this.parentcontrol = p;
    this.link = o;
    this.target = wcbs.dom.get(this.link.getattr("href").substring(this.link.getattr("href").indexOf("#") + 1));

    if (this.target.object != null) {
        var self = this;

        this.startscroll = function (event) {
            event.preventDefault();
            self.parentcontrol.startscroll(self.target);
            return false;
        }

        this.link.event("mousedown", self.startscroll);
    }

}
